import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=ed4197b4&scoped=true&"
import script from "./Packages.vue?vue&type=script&lang=ts&"
export * from "./Packages.vue?vue&type=script&lang=ts&"
import style0 from "./Packages.vue?vue&type=style&index=0&id=ed4197b4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4197b4",
  null
  
)

export default component.exports